export default class utilManager {
    constructor() {
    }
    winRatePcW($val){
        return $val / 1600 * window.innerWidth;
    }
    winRatePcH($val){
        return $val / 900 * window.innerHeight;
    }
    // 値のマッピング
    // -----------------------------------
    // @num     : マッピングする値
    // @toMin   : 変換後の最小値
    // @toMax   : 変換後の最大値
    // @fromMin : 変換前の最小値
    // @fromMax : 変換前の最大値
    // -----------------------------------
    map(num, toMin, toMax, fromMin, fromMax){
        if(num <= fromMin) return toMin;
        if(num >= fromMax) return toMax;

        let p = (toMax - toMin) / (fromMax - fromMin);
        return ((num - fromMin) * p) + toMin;

    }



}